<template>
  <div id="fy_container" class="parent_container">
    <div class="child_container" :class="{'child_reverse': container.isReverse}">
      <div class="detail" :class="{'fy_reverse_detail':container.isReverse}">
        <div class="fy_container_title">
          <h2 v-for="item in container.title">{{item}}</h2>
        </div>
        <h4 v-for="(item,index) in container.h4" :key="index">{{item}}</h4>
      </div>
     <div class="fy_container_img pull-right" :class="{'fy_reverse_img':container.isReverse}">
       <img class="img-responsive" :src="container.imgSrc">
     </div>
    </div>
  </div>
</template>

<script>
  import './../assets/css/fy_container.css'
    export default {
        name: "fy_container",
        props:['container'],
        data() {
            return {
                isShow: true
            }
        },
        mounted() {
            // setInterval(()=>{
            //     this.isShow = !this.isShow
            // },500)
        },
        methods:{
            // isShowFunc() {
            //     console.log('执行一次' + this.isShow)
            //     return this.isShow
            // }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_container.vue